import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  const { isAuthed, requireAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onClick = () => {
    if (!isAuthed) {
      requireAuth({ redirectTo: "/listings" });
      return;
    }
    navigate("/listings");
  };

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-30 sticky-cta bg-white border-t border-[#E4E1D9] px-4 py-3 transition-transform duration-300 ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
      data-testid="sticky-cta"
    >
      <button
        onClick={onClick}
        className="btn-primary w-full justify-center !py-3.5"
        data-testid="sticky-get-started-btn"
      >
        Get Started
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
}
